<template>
    <div class="modal" ref="addUpdateContactFieldModal" id="addUpdateContactFieldModal" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">

                <div class="modal-header bg-white font-bold">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Update Field</h5>
                    <button type="button" class="close text-black" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-grey-darkest">
                    <div class="pt-2 pb-2 px-3">
                        <div class="pt-2 pb-2 px-3">

                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" for="cell">Cell</label>
                                    <input v-model="form.cell" id="cell" name="cell" maxlength="64"
                                        v-mask="masks.v_mask_phone"
                                        class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3">
                                </div>

                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" for="title">Title</label>
                                    <input v-model="form.title" type="text" id="title" name="title" maxlength="64"
                                        class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3">
                                </div>
                            </div>

                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" for="team_contact_status">Status</label>
                                    <select name="team_contact_status" id="team_contact_status"
                                            v-model="form.team_contact_status"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3">
                                        <option v-for="item in contactStatuses" :value="item.id">{{ item.name }}</option>
                                    </select>
                                </div>

                                <div class="mb-2 ml-2 leading-tight w-full row">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3" for="contact_type">Contact Type</label>
                                    <select name="contact_type" id="contact_type"
                                            v-model="form.contact_type"
                                            class="appearance-none bg-white border-1 focus:outline-none p-1 rounded text-grey-darkest text-sm w-1/2 md:w-2/3">
                                        <option selected></option>
                                        <option v-for="contactType in contactTypes" :value="contactType.id" :key="contactType.id">
                                            {{ contactType.code }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="flex flex-wrap">
                                <div class="mb-2 ml-2 leading-tight w-full row" v-for="(field, index) in custom_fields" :key="field.id">
                                    <label class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                                            for="contract_type_id">{{ field.label_value }}</label>
                                    <div v-if="field.options.length == 0" class="w-1/2 md:w-2/3">
                                        <input type="text" :name="field.name" :id="field.name + '-' + field.id" v-model="form.custom_fields[field.id]"
                                                class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full">
                                    </div>
                                    <div v-if="field.options.length > 0" class="w-1/2 md:w-2/3">
                                        <select :name="field.name" :id="field.name + '-' + field.id"
                                                v-model="form.custom_fields[field.id]"
                                                class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full">
                                            <option value="0"> - </option>
                                            <option v-for="option in field.options" :value="option.id" :key="option.id"> {{option.name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary assign-user-btn" @click.prevent="massUpdate()">
                        Update <i v-if="loadingUpdate" class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Swal from "sweetalert2";

export default {
    name: 'update-contact-field',
    props: {
        checked_contact_ids: { type: Array },
        masks: {},
        contactStatuses: {},
        isContactResidentialActive : {},
    },

    data() {
        return {
            loadingUpdate: false,
            custom_fields: {},
            form: new Form({
                contact_ids: [],
                cell: '',
                title: '',
                team_contact_status: '',
                contact_type: '',
                custom_fields: [],
            }),
            contactTypes: [],
        }
    },

    created() {
        this.getContactTypes();
        this.fetchCustomFields();
    },

    mounted() {
        $("#addUpdateContactFieldModal").on('hidden.bs.modal', () => this.clear());
    },

    methods: {
        open() {
            $(this.$el).modal('show');
            this.form.contact_ids = [ ...this.checked_contact_ids ];
        },

        fetchCustomFields(){
            let self = this;
            axios.get(route('api.contact-custom-field.index') + '?contact=true').then(({data}) => {
                self.custom_fields = data.data;
                let custom = [];
                for (let field in self.custom_fields) {
                    custom[self.custom_fields[field].id] = ''
                }
                self.form.custom_fields = new Form(custom);
            });
        },

        getContactTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                // self.contactTypes = data;
                if(!self.isContactResidentialActive){
                    self.contactTypes = data.filter(contactType => contactType.is_residential !== 1)
                }else{
                    self.contactTypes = data.filter(contactType => contactType.is_residential === 1)
                }
            });
        },

        close() {
            $(this.$el).modal('hide');
            this.clear();
        },

        clear() {
            this.form.contact_ids = [];
        },

        massUpdate()
        {
            this.loadingUpdate = true;
            let titleString = this.form.contact_ids.length == 1 ? this.form.contact_ids.length+' contact is selected, are you sure you want to update it?' : this.form.contact_ids.length+' contacts are selected, are you sure you want to update them?';
            let textString = this.form.contact_ids.length == 1 ? 'Record' : 'Records';
            Swal.fire({
                title: titleString,
                text: textString+" can't be undo once updated.",
                icon: "warning",
                buttons: true,
                showCancelButton: true,
                confirmButtonColor: 'red',
                confirmButtonText: 'I\'m sure!',
                closeOnConfirm: true,
                closeOnCancel: true,
            }).then(result => {
                if (result.value) {
                    this.form.post('/api/contact/mass-update/update-field')
                        .then( (data) => {
                            this.loadingUpdate = false;
                            this.close();
                            this.$emit('update-finished', data);
                        })
                        .catch( (err) => {
                            this.loadingUpdate = false;
                            console.error(err);
                        });
                }
            });
        }
    }
}
</script>

<style scoped>
    .assign-user-btn {
        border-radius: 25px !important;
    }
</style>
